import React from 'react';
import { FlexBox } from '@monorepo/ui-kit';
import Column from '../Column';
import styles from './index.module.css';

const BackOffice: FC = ({ className = '', layout, components = [] }) => {
  const { columns, type } = layout;

  return (
    <FlexBox className={`${styles.wrap} ${styles[type]}`}>
      <Column
        key={columns[0].join('/')}
        column={columns[0]}
        className={styles.menuColumn}
        components={components}
      />
      <div className={styles.officeWrap}>
        <Column
          key={columns[1].join('/')}
          column={columns[1]}
          className={styles.officeColumn}
          components={components}
        />
      </div>
    </FlexBox>
  );
};

export default BackOffice;
